import script from "./ResetPasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordView.vue?vue&type=script&setup=true&lang=js"

import "./ResetPasswordView.vue?vue&type=style&index=0&id=e8414da2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8414da2"]])

export default __exports__